// extracted by mini-css-extract-plugin
module.exports = {"promotion__body":"promotion__body-21akx","promotion__img":"promotion__img-3aaYg"};